import './_people-slider-styles.scss';

import './people-slider';
